import { executeSaleVoidRemoteIntake } from './saleVoidIntake';

/** Anula venta en servidor (ADR-017 full online). */
export async function executeVoidSaleCommand(params: {
  saleId: string;
  branchId: string;
  voidReason: string;
  voidedByUserId?: string | null;
  fiscalMode?: string;
  supervisorOverrideId?: string;
}): Promise<void> {
  await executeSaleVoidRemoteIntake(params);
}
